/**
 * メンバータイプ。
 * Guestは非会員
 * Memberは会員
 */
export const MemberType = {
    Guest: "Guest",
    Member: "Member",
    Business: "Business",
    Customer: "Customer"
} as const;
export type MemberType = typeof MemberType[keyof typeof MemberType];